import { setMessagesExpirePeriod } from 'utils/helpers'
import * as types from './constants'

const initialState = {
  disclaimerContent: '',
  gdprContent: '',
  savingStatus: 0,
  previousState: null,
  showDisclaimer: false,
  disclaimerShowing: false,
  showGdpr: false,
  generalSettingsLoaded: false,
  disclaimerAgree: false,
  pdfViewer: 'google',
  dashboardType: 1,
  certificateType: 1,
  displayUsersBy: 1,
  sendWelcomeEmail: false,
  defaultTab: '',
  contactEmail: null,
  messagesArchivePeriod: {},
  showFirstLink: false,
  userRewardsOnDashboard: false,
  leaderBoardOnDashboard: false,
  corporateHierarchy: false,
  publicCatalogPercentage: false,
  allowAllLocationsAccess: false,
  certificateFooter: false,
  certificateFooterContent: '',
  managerAlertOnDashboard: false,
  pdfjsDownloadAndPrint: false,
  allowSignup: false,
  askCountry: false,
  askAge: false,
  enableLanguageFiles: false,
  comboardNotifications: false,
  autoCompleteForms: false,
  disableLocationForms: false,
  firstLink: {
    id: 1,
    icon: '',
    name: '',
    URL: '',
  },
  showSecondLink: false,
  secondLink: {
    id: 2,
    icon: '',
    name: '',
    URL: '',
  },
  showThirdLink: false,
  thirdLink: {
    id: 3,
    icon: '',
    name: '',
    URL: '',
  },
  external_apps: {},
  isBlocking: false,
  showSidebarDropdownChildRoutes: false,
}

const generalConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ON_CHANGE:
      return {
        ...state,
        disclaimerContent: action.text,
      }
    case types.TOGGLE_DISCLAIMER_PAGE:
      return {
        ...state,
        showDisclaimer: action.isShowing,
      }
    case types.SET_DISCLAIMER_SHOWING:
      return {
        ...state,
        disclaimerShowing: action.isShowing,
      }
    case types.ON_CHANGE_GDPR:
      return {
        ...state,
        gdprContent: action.text,
      }
    case types.ON_CHANGE_CERTIFICATE_FOOTER:
      return {
        ...state,
        certificateFooterContent: action.text,
      }
    case types.TOGGLE_GDPR_PAGE:
      return {
        ...state,
        showGdpr: action.isShowing,
      }
    case types.GENERAL_PAGE_STATUS:
      return {
        ...state,
        savingStatus: action.status,
      }
    case types.GENERAL_PRESENT:
      const { previousState, ...otherProps } = state

      return {
        ...state,
        previousState: JSON.stringify(otherProps),
      }
    case types.GENERAL_UNDO:
      return {
        ...state,
        ...JSON.parse(state.previousState),
      }
    case types.SET_GENERAL_SETTINGS:
      return {
        ...state,
        ...action.data,
        disclaimerShowing: action.data.showDisclaimer,
        sendWelcomeEmail: action.data.sendWelcomeEmail === 1 ? true : false,
        userRewardsOnDashboard:
          action.data.user_rewards_on_dashboard === 1 ? true : false,
        leaderBoardOnDashboard:
          action.data.leaderboard_on_dashboard === 1 ? true : false,
        corporateHierarchy:
          action.data.corporate_hierarchy === 1 ? true : false,
        publicCatalogPercentage:
          action.data.public_catalog_percentage === 1 ? true : false,
        allowAllLocationsAccess:
          action.data.allow_all_locations_access === 1 ? true : false,
        certificateFooter: action.data.certificate_footer === 1 ? true : false,
        managerAlertOnDashboard:
          action.data.manager_alert_on_dashboard === 1 ? true : false,
        pdfjsDownloadAndPrint:
          action.data.pdfjs_download_and_print === 1 ? true : false,
        allowSignup: action.data.allow_signup === 1 ? true : false,
        askCountry: action.data.ask_country === 1 ? true : false,
        askAge: action.data.ask_age === 1 ? true : false,
        enableLanguageFiles:
          action.data.enable_language_files === 1 ? true : false,
        comboardNotifications:
          action.data.comboard_notifications === 1 ? true : false,
        autoCompleteForms: action.data.auto_complete_forms === 1 ? true : false,
        disableLocationForms:
          action.data.disable_location_forms === 1 ? true : false,
        messagesArchivePeriod: setMessagesExpirePeriod(
          action.data.messages_expire_period
        ),
      }
    case types.GENERAL_SETTINGS_ID:
      return {
        ...state,
        id: action.id,
      }
    case types.SET_CERTIFICATE_TYPE:
      return {
        ...state,
        certificateType: action.certificateType,
      }
    case types.GENERAL_SETTINGS_LOADED:
      return {
        ...state,
        generalSettingsLoaded: true,
      }
    case types.GENERAL_DISCLAIMER_AGREE:
      return {
        ...state,
        disclaimerAgree: true,
      }
    case types.SET_PDF_VIEWER:
      return {
        ...state,
        pdfViewer: action.selectedPdfViewer,
      }
    case types.SET_DASHBOARD_TYPE:
      return {
        ...state,
        dashboardType: action.dashboardType,
      }
    case types.DISPLAY_USERS_BY:
      return {
        ...state,
        displayUsersBy: action.displayUsersBy,
      }
    case types.SET_GDPR_DATA:
      return {
        ...state,
        gdprContent: action.gdprContent,
        showGdpr: action.showGdpr,
      }
    case types.TOGGLE_WELCOME_EMAIL:
      return {
        ...state,
        sendWelcomeEmail: !state.sendWelcomeEmail,
      }
    case types.ON_TOGGLE_FIRST_EXTERNAL_LINK:
      return {
        ...state,
        showFirstLink: !state.showFirstLink,
      }
    case types.ON_TOGGLE_SECOND_EXTERNAL_LINK:
      return {
        ...state,
        showSecondLink: !state.showSecondLink,
      }
    case types.ON_TOGGLE_THIRD_EXTERNAL_LINK:
      return {
        ...state,
        showThirdLink: !state.showThirdLink,
      }
    case types.SET_DEFAULT_TAB:
      return {
        ...state,
        defaultTab: action.defaultTab,
      }
    case types.SET_CONTACT_EMAIL:
      return {
        ...state,
        contactEmail: action.contactEmail,
      }
    case types.ON_CHANGE_EXTERNAL_LINK:
      switch (action.groupId) {
        case '1':
          return {
            ...state,
            firstLink: {
              ...state.firstLink,
              [action.name]: action.value,
            },
          }
        case '2':
          return {
            ...state,
            secondLink: {
              ...state.secondLink,
              [action.name]: action.value,
            },
          }
        case '3':
          return {
            ...state,
            thirdLink: {
              ...state.thirdLink,
              [action.name]: action.value,
            },
          }
        default:
          break
      }
    case types.GET_EXTERNAL_LINKS:
      return {
        ...state,
        showFirstLink: action.data[0].enabled === 1 ? true : false,
        firstLink: { name: action.data[0].name, URL: action.data[0].url },
        showSecondLink: action.data[1].enabled === 1 ? true : false,
        secondLink: {
          name: action.data[1].name,
          URL: action.data[1].url,
        },
        showThirdLink: action.data[2].enabled === 1 ? true : false,
        thirdLink: {
          name: action.data[2].name,
          URL: action.data[2].url,
        },
      }
    case types.GET_EXTERNAL_APPS:
      return {
        ...state,
        external_apps: { ...state.external_apps, ...action.data },
      }

    case types.ENABLE_USER_REWARDS:
      return {
        ...state,
        userRewardsOnDashboard: !state.userRewardsOnDashboard,
      }
    case types.ENABLE_LEADERBOARD:
      return {
        ...state,
        leaderBoardOnDashboard: !state.leaderBoardOnDashboard,
      }
    case types.ENABLE_CORPORATE_HIERARCHY:
      return {
        ...state,
        corporateHierarchy: !state.corporateHierarchy,
      }
    case types.ENABLE_PUBLIC_CATALOG_PERCENTAGE:
      return {
        ...state,
        publicCatalogPercentage: !state.publicCatalogPercentage,
      }
    case types.ALLOW_ALL_LOCATIONS_ACESS:
      return {
        ...state,
        allowAllLocationsAccess: !state.allowAllLocationsAccess,
      }
    case types.ENABLE_CERTIFICATE_FOOTER:
      return {
        ...state,
        certificateFooter: !state.certificateFooter,
      }
    case types.ENABLE_PDFJS_DOWNLOAD_AND_PRINT:
      return {
        ...state,
        pdfjsDownloadAndPrint: !state.pdfjsDownloadAndPrint,
      }
    case types.ALLOW_SIGNUP:
      return {
        ...state,
        allowSignup: !state.allowSignup,
      }

    case types.ASK_COUNTRY:
      return {
        ...state,
        askCountry: !state.askCountry,
      }
    case types.ASK_AGE:
      return {
        ...state,
        askAge: !state.askAge,
      }

    case types.ENABLE_LANGUAGE_FILES:
      return {
        ...state,
        enableLanguageFiles: !state.enableLanguageFiles,
      }

    case types.AUTO_COMPLETE_FORMS:
      return {
        ...state,
        autoCompleteForms: !state.autoCompleteForms,
      }

    case types.DISABLE_LOCATION_FORMS:
      return {
        ...state,
        disableLocationForms: !state.disableLocationForms,
      }

    case types.ENABLE_COMBOARD_NOTIFICATIONS:
      return {
        ...state,
        comboardNotifications: !state.comboardNotifications,
      }
    case types.ENABLE_MANAGER_ALERT:
      return {
        ...state,
        managerAlertOnDashboard: !state.managerAlertOnDashboard,
      }
    case types.SET_IS_BLOCKING:
      return {
        ...state,
        isBlocking: action.isBlocking,
      }

    case types.SET_MESSAGES_ARCHIVE_PERIOD:
      return {
        ...state,
        messagesArchivePeriod: action.payload,
      }

    case types.SET_SHOW_SIDEBAR_CHILD_ROUTES:
      return {
        ...state,
        showSidebarDropdownChildRoutes: action.payload,
      }
    default:
      return state
  }
}

export default generalConfigReducer
